import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { ItemIcon, GenericAssetItem } from "@similarweb/ui-components";

type StyledRecentItemProps = {
    isDisabled: boolean;
};

export const StyledRecentItem = styled(GenericAssetItem)<StyledRecentItemProps>`
    ${({ isDisabled }) =>
        isDisabled &&
        `
        background-color: ${colorsPalettes.bluegrey[200]};
        border-color: ${colorsPalettes.midnight[50]};
        color: ${colorsPalettes.carbon[400]};
        cursor: not-allowed;
    `}
`;

export const StyledRecentItemIcon = styled(ItemIcon)`
    flex: none;
`;
